"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataTypes;
(function (DataTypes) {
    DataTypes[DataTypes["circle"] = 0] = "circle";
    DataTypes[DataTypes["line"] = 1] = "line";
    DataTypes[DataTypes["bar"] = 2] = "bar";
    DataTypes[DataTypes["flag"] = 3] = "flag";
    DataTypes[DataTypes["area"] = 4] = "area";
})(DataTypes = exports.DataTypes || (exports.DataTypes = {}));
//# sourceMappingURL=dataset.interface.js.map